export const ClockTypesEnum = {
  clock_with_stats: 'clock_with_stats',
  stats_only: 'stats_only',
  penalty_clock_only: 'penalty_clock_only',
  game_and_penalty_clock: 'game_and_penalty_clock',
}